import React from "react";
import SingleLineField from "../forms/SingleLineField";
import FormModal, { validateEmail } from "./FormModal";
import ImageUploadField from "../forms/ImageUploadField";

export default function AddAdvertiserModal({ onOk, ...props }) {

  const handleOnOk = async (values) => {
    const trimmedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.trim() : value,
      ]),
    );

    if (trimmedValues.adminEmail) {
      validateEmail(trimmedValues.adminEmail, 'adminEmail')
    }

    const record = Object.entries({
      country: "DK",
      ...trimmedValues,
    }).reduce((acc, [key, value]) => {
      if (value !== '' && value !== undefined && value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});

    onOk(record)
  }

  return (
    <FormModal
      title="Add Advertiser"
      okText="Add"
      onOk={handleOnOk}
      {...props}
    >
      <SingleLineField
        label="Name"
        top
        required
        htmlfor="name" />
      <ImageUploadField name="image" label="Logo"/>
      <SingleLineField
        label={"Account Admin First Name"}
        htmlfor="adminFirstName" />
      <SingleLineField
        label={"Account Admin Last Name"}
        htmlfor="adminLastName" />
      <SingleLineField
        label={"Account Admin Email"}
        htmlfor="adminEmail" />
    </FormModal>
  )
}
